<template>
  <div>
    <span>{{ attributeData.displayName }}</span>
    <MediaFilePicker
      label=""
      :multiple="false"
      :value="value"
      @change="$emit('input', $event)"
    />
    <ErrorMessage :message="errorMessage"/>
  </div>
</template>

<script>
import MediaFilePicker from '@/components/media-file-picker'
import ErrorMessage from '@/components/error-messages/ErrorMessage'

export default {
  name: 'attribute-field-FILE',
  components: {
    ErrorMessage,
    MediaFilePicker
  },
  props: {
    attributeData: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Number,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
